import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 13.928 15"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M11.648 6.607a.536.536 0 0 0-.4-.178h-8.57a.536.536 0 0 0-.539.533.53.53 0 0 0 0 .06l.8 7.5a.536.536 0 0 0 .536.479h6.964a.536.536 0 0 0 .536-.479l.8-7.5a.536.536 0 0 0-.127-.415ZM12.857 2.991h-2.679a.268.268 0 0 1-.268-.268v-.848A1.877 1.877 0 0 0 8.035 0h-2.14a1.884 1.884 0 0 0-1.878 1.846l-.013.881a.269.269 0 0 1-.268.265H1.071a1.071 1.071 0 0 0 0 2.143h11.786a1.071 1.071 0 0 0 0-2.143Zm-7.233-1.12a.269.269 0 0 1 .268-.264h2.143a.268.268 0 0 1 .268.268v.849a.268.268 0 0 1-.268.268H5.879a.269.269 0 0 1-.268-.27Z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }